module.exports = __webpack_public_path__ + "static/media/venvi4.aed018da.gif";